// extracted by mini-css-extract-plugin
export var backgroundImage = "large-partners-module--backgroundImage--978d7";
export var container = "large-partners-module--container--08d4d";
export var partner = "large-partners-module--partner--ba3eb";
export var partners = "large-partners-module--partners--f1ccf";
export var redirectLink = "large-partners-module--redirectLink--4e867";